import { Token } from "inversify-token";
import { CardsDynamicConfiguration } from "./CardsDynamicConfiguration";

export const CardsDynamicConfigurationProviderToken = new Token<CardsDynamicConfigurationProvider>(Symbol.for("CardsDynamicConfigurationProvider"));

export interface CardsDynamicConfigurationProvider {
  get(): CardsDynamicConfiguration;
}
